














import {
	defineComponent,
	markRaw,
	PropType,
	Ref,
	ref,
	watch,
} from '@vue/composition-api';
// import 'survey-knockout/survey.css';
import 'survey-core/modern.min.css';
import { Component } from 'vue';
import { Survey } from 'survey-vue-ui';
// import { Model } from 'survey-vue';
import { Model, SurveyModel, StylesManager } from 'survey-core';
import { SurveyAnswersResponse } from '@front-app/api-generated/learning-management-api';
import { getSurveysStore } from '@front-app/modules/surveys/store/SurveysStore';
import { useAsyncStatus } from '@front-app/hooks/useAsyncStatus';
import LoaderState from '@front-app/components/LoaderState.vue';
import ErrorCard from '@front-app/components/cards/state/ErrorCard.vue';
import { LearningStep } from '../Model';

StylesManager.applyTheme('modern');

interface EventOptions {
	showDataSaving(): void;
	showDataSavingError(): void;
	showDataSavingSuccess(): void;
	showDataSavingClear(): void;
	isCompleteOnTrigger(): void;
}

export default defineComponent({
	components: {
		SurveyVue: Survey as Component,
		ErrorCard,
		LoaderState,
	},
	props: {
		step: {
			type: Object as PropType<LearningStep>,
			required: true,
		},
	},
	setup(props, ctx) {
		const surveysStore = getSurveysStore();
		const survey: Ref<null | Model> = ref(null);
		const { track, isLoading, isError } = useAsyncStatus();
		watch(() => props.step.content.id, async (surveyId) => {
			await track(surveysStore.fetchSurvey(surveyId));
			const { surveyContent, userResponse } = surveysStore.getSurvey(surveyId);
			if (!userResponse) {
				const surveyModel = getNewSurveyModel(surveyContent);
				surveyModel.onComplete
					.add(async (surveyResponse: SurveyModel, options: EventOptions) => {
						options.showDataSaving();
						await surveysStore.answerSurvey(surveyId, {
							answersContent: JSON.stringify(surveyResponse.data),
						});
						options.showDataSavingSuccess();
						ctx.emit('done', JSON.stringify(surveyResponse.data));
					});
				survey.value = surveyModel;
			} else {
				survey.value = getCompletedSurveyModel(surveyContent, userResponse);
			}
		}, { immediate: true });
		return {
			survey,
			isLoading,
			isError,
		};
	},
});

function getNewSurveyModel(surveyContent: string): Model {
	return markRaw(new Model(JSON.parse(surveyContent)));
}

function getCompletedSurveyModel(surveyContent: string, userResponse: SurveyAnswersResponse): Model {
	const surveyModel = new Model(userResponse.originalSurveyContent || surveyContent);
	surveyModel.mode = 'display';
	surveyModel.data = JSON.parse(userResponse.answersContent);
	return markRaw(surveyModel);
}
